import { path as parentPath } from "../init";

export const path = `${parentPath}/prompts`;

export const apiUrls = {
  list: "/api/specials/prompts",
  prompt: "/api/specials/prompts/prompt",
  positions: "/api/specials/prompts/positions",
  info: "/api/specials/prompts/prompt_{promptId}",
  start: "/api/specials/prompts/prompt_{promptId}/start",
};

export const infoLink = (source) => {
  return `${path}/prompt_${source._id}`;
};

export const formLink = (schedule) => {
  return `${infoLink(schedule)}/form`;
};
